var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDownloadAppIcon = function SvgDownloadAppIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.64 13.92a.96.96 0 00-.96.96v3.84a.96.96 0 01-.96.96H5.28a.96.96 0 01-.96-.96v-3.84a.96.96 0 10-1.92 0v3.84a2.88 2.88 0 002.88 2.88h13.44a2.88 2.88 0 002.88-2.88v-3.84a.96.96 0 00-.96-.96zm-9.321 1.642a.96.96 0 00.317.201.902.902 0 00.73 0 .96.96 0 00.316-.201l3.84-3.84a.964.964 0 00-1.363-1.364l-2.199 2.208V3.36a.96.96 0 00-1.92 0v9.206l-2.198-2.208a.965.965 0 00-1.363 1.364l3.84 3.84z",
    fill: "url(#DownloadAppIcon_svg__vn6qlorp7a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "DownloadAppIcon_svg__vn6qlorp7a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.72226 14.9308 -15.5297 6.9919 5.278 6.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgDownloadAppIcon;